import { user } from "./user"

const SYSTEM_MESSAGES = {
    ...user
}

export default SYSTEM_MESSAGES